import _ from 'underscore'
import Backbone from 'backbone'
import TextTemplate from '../templates/text.tpl'

const SchoolPinView = Backbone.View.extend({
    className: 'userm-pin-text',
    initialize() {
        this.template = _.template(TextTemplate)
        this.listenTo(this.model, 'change', this.render)
    },
    render() {
        this.$el.html(this.template({text: this.model.get('pin')}))
        return this
    }
})

export default SchoolPinView
